import { CopyOutlined } from '@ant-design/icons';
import { App } from 'antd';
import { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Text } from '@atom/typography/typography';

interface WebhookSecretProps {
  secret: string;
}

export const WebhookSecret = memo(({ secret }: WebhookSecretProps) => {
  const [isSuccess, setSuccess] = useState(false);
  const { message } = App.useApp();

  useEffect(
    () =>
      void (isSuccess && message.success('Webhook secret was successfully copied', () => setSuccess(false)),
      [isSuccess]),
  );

  return (
    <Text paragraph>
      Webhook Secret:
      <CopyToClipboard text={secret} onCopy={() => setSuccess(true)}>
        <span style={{ cursor: 'pointer' }}>
          {secret} <CopyOutlined />
        </span>
      </CopyToClipboard>
    </Text>
  );
});
